import React, { useMemo } from "react";

// Signature element: a scrolling oscilloscope "carrier signal".
// Idles slow + quiet; speeds up + brightens when `active` (Morpheus transmitting).
function buildWave(width, mid, amp, period, phase = 0) {
  let d = `M0 ${mid}`;
  for (let x = 0; x <= width; x += 4) {
    const y = mid + amp * Math.sin((2 * Math.PI * x) / period + phase);
    d += ` L${x.toFixed(1)} ${y.toFixed(2)}`;
  }
  return d;
}

export default function CarrierSignal({ active = false, className = "" }) {
  const { wave, waveFlare } = useMemo(() => ({
    wave: buildWave(2400, 30, 11, 120, 0),
    waveFlare: buildWave(2400, 30, 7, 160, Math.PI / 3),
  }), []);

  return (
    <div className={`carrier ${active ? "carrier--active" : ""} ${className}`} aria-hidden="true">
      <svg className="carrier__svg" viewBox="0 0 2400 60" preserveAspectRatio="none">
        <path className="carrier__path carrier__path--flare" d={waveFlare} />
        <path className="carrier__path" d={wave} />
      </svg>
    </div>
  );
}
